export default "__VITE_ASSET__fPYsMH$Z__"